module.exports = __webpack_public_path__ + "img/MEDIA086.0235cb0a.jpg";